import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
//import { formComponentMapOptions } from '~/front-models/form-component-map';
import { ReceiveTransaction, ShipTransaction } from '~/front-models/transactionGrid';
import { ComponentBase } from '~/infrastructure/component-base';
import { GridFieldSummary } from '~/models/modules/gridField';
import { StockItemSummary } from '~/models/modules/item';
import { AccountsService } from '~/services/administration.ts/accounts';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationsService } from '~/services/modules/stocks/locations';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { InventoriesService } from '~/services/modules/stocks/inventories';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { ReportViewerPopupComponent } from '../../../../shared/components/viewer/popup.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { FormatService } from '~/services/administration.ts/format';
import { TransactionDateEditingService } from '~/services/modules/stocks/administration/transaction-date-editing';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';


@Component({
    selector: 'app-stock-breakdown',
    templateUrl: './breakdown.html',
    styleUrls: ['./breakdown.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockBreakdownComponent extends ComponentBase implements OnInit {
    _costFormat: string;

    _currentUser: UserSummary;
    _theme: string;
    _form: FormGroup;
    _barcodePopupForm: FormGroup;
    _barcodePopupFormFields: any = [];
    _invalidForm: boolean;
    _model: any;
    _selectedAccount = new FormControl();

    _sortingSelected = new FormControl('old');
    _quickScan = new FormControl();
    _defaultQuantity = new FormControl();
    _defaultDate = new FormControl();
    _autoCodeGeneration = new FormControl();
    _inventoryCode = new FormControl();
    _quantity = new FormControl();
    _expirationDate = new FormControl();
    _sites: any[] = [];
    _sitesFiltered: any[] = [];
    _locations: any[] = [];
    _locationsFiltered: any[] = [];
    _purchaseOrders: any[] = [];
    _purchaseOrdersFiltered: any[] = [];
    _vendors: any[] = [];
    _vendorsFiltered: any[] = [];
    _selectedStockItem = new FormControl();
    _items: any[] = [];
    _itemsFiltered: any[] = [];
    _breakdownInventories: any[] = [];
    _breakdownInventoriesFiltered: any[] = [];
    _selectedBreakdownInventory = new FormControl();
    _selectedLocation = new FormControl();
    _breakdownQuantity = new FormControl();
    _notes = new FormControl();
    _inventoryGridData: any[] = []; //create Breakdown Transaction class for the grid
    _itemType: 'standard' | 'batch' | 'serial' | 'serial-with-quantity' | 'non-inventory';
    _barcodePopupActive: boolean;
    _minDate: Date = new Date(1901, 1, 1);
    _printReceipt = new FormControl();
    _showStocksGrid: boolean = false;
    _selectedStocks: StockItemSummary[] = [];
    _stockItemsGridColumns: GridFieldSummary[];
    _settingsPrintReceipt: any;
    transactionId: number;
    showReports: boolean = false;
    _selectedCallback = (args: { dataItem: any; }) => args.dataItem;
    receiveReports: any[] = [];
    _poPreference: any;
    _addNewStockSettingEnabled: boolean = true; //get from receive settings
    _itemFilter: string;
    _personIDtData: Array<string> = [
        'Person 1',
        'Person 2',
        'Person 3'
    ];
    _addClassActive: boolean = false;
    OpenSignAndProcessForm: boolean = false;
    OpenCreateShippingAndProcessForm: boolean = false;

    _datePickerFormat: string;

    _dateEnabled: boolean;


    quantityFormat: string;
    digitNumber: number;


    @ViewChild('quantity_input') quantityInput: NumericTextBoxComponent;
    @ViewChild('breakdown_quantity_input') breakdownQuantityInput: NumericTextBoxComponent;
    @ViewChild('Kendo_Input_Transaction_note') KendoInputTransactionnote: ElementRef;
    @ViewChild('Kendo_Input_Notes') KendoInputNotes: ElementRef;
    @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
    @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
    @ViewChild('kendo_combo_breakdown_inventory') kendoComboBreakdownInventory: ComboBoxComponent;
    @ViewChild('kendo_combo_breakdown_location') kendoComboBreakdownLocation: ComboBoxComponent;
    @ViewChild('kendo_combo_stock_item') kendoComboStockItem: ComboBoxComponent;


    isGeneralInformationExpanded: boolean = true;
    isScanInventoryExpanded: boolean = true;



    constructor(
        private _fb: FormBuilder,
        private _themeManager: ThemeManagerService,
        private _accountsService: AccountsService,
        private _locationsService: LocationsService,
        private _receiveTransactionsService: ReceiveTransactionsService,
        private _stockItemsService: StockItemsService,
        private _inventoriesService: InventoriesService,
        private _barcodeGeneratorsService: BarcodeGeneratorsService,
        private _layoutComponent: LayoutComponent,
        private _layoutManager: LayoutManagerService,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _gridFields: GridFieldsService,
        private _securityService: SecurityService,
        private _formatService: FormatService,
        private quantityFormatsService: QuantityFormatsService,
        private _TransactionDateEditting: TransactionDateEditingService
    ) {
        super();
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });

        this.LoadData();
        this._gridFields
            .getGridFieldsByPage('stockItems')

            .subscribe((data: any) => {
                this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
            });

        this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
            this._stockItemsGridColumns = gridColumns;
        }));
        this._currentUser = this._securityService.currentUser;
    }



    async LoadData() {
        this.quantityFormat = await this.quantityFormatsService.getQuantityFormatForNumericTextBox();
        this.digitNumber = await this.quantityFormatsService.getDigitNumber(this.quantityFormat);
    }




    ngOnInit() {
        this._initForm();
        this._OpenAccount();

        /** Format */
        this._datePickerFormat = this._formatService.dateFormat;
        this._costFormat = this._formatService.costFormatValue;
        this.getDateEnabledOption();

        setTimeout(() => {
            const currentSite = this._form.get('site')?.value;
            const siteId = currentSite && typeof currentSite === 'object' ? currentSite.id : currentSite;
            if (siteId) {
                this._loadAllDropdowns(siteId);
            }
        });

        this._form.get('site')?.valueChanges.subscribe((site: any) => {
            const siteId = site && typeof site === 'object' ? site.id : site;
            if (siteId) {
                this._loadAllDropdowns(siteId);
            }
        });

        this._selectedAccount.valueChanges.subscribe((acc: any) => {
            if (acc) {
                this._form.get('site')?.setValue(null);
                this._accountsService
                    .getSitesListByAccount(acc.id)
                    .subscribe((data: any) => {
                        const sites = Array.isArray(data) ? data : (data?.body ?? data?.data ?? []);
                        this._sites = sites;
                        this._sitesFiltered = this._sites;
                        setTimeout(() => {
                            this.kendoComboSites?.toggle(true);
                            this.kendoComboSites?.focus();
                        });
                    });
            }
        });

        this._selectedLocation.valueChanges.subscribe((loc: any) => {
            if (loc) {
                this._form.patchValue({ location: loc });
            }
        });
    }

    _loadAllDropdowns(siteId: number) {
        this._loadLocationsDD(siteId);
        this._loadItemsDD(siteId);
        this._loadBreakdownInventories(siteId);
    }

    _onSiteChanged(site: any) {
        const siteId = site && typeof site === 'object' ? site.id : site;
        if (siteId) {
            this._form.get('site')?.setValue(site);
            this._loadAllDropdowns(siteId);
        }
    }

    _loadBreakdownInventories(siteId: number) {
        return this._inventoriesService.getInventoryListing(siteId)
            .subscribe((data: any) => {
                const invs = Array.isArray(data) ? data : (data?.body ?? data?.data ?? []);
                this._breakdownInventories = invs;
                this._breakdownInventoriesFiltered = invs;
            });
    }

    _handleBreakdownInventoriesFilter(value: any) {
        if (!value) {
            this._breakdownInventoriesFiltered = this._breakdownInventories;
            return;
        }
        const search = typeof value === 'string' ? value.toLowerCase() : '';
        this._breakdownInventoriesFiltered = (this._breakdownInventories || []).filter(
            (s) => s.inventoryNumber?.toString().toLowerCase().indexOf(search) !== -1
        );
    }

    _handleBreakdownInventoryChange(item: any) {
        if (item) {
            if (item.availability !== undefined && item.availability !== null) {
                this._breakdownQuantity.setValue(item.availability);
            }
            if (item.locationId && this._locations) {
                const foundLoc = this._locations.find(l => l.id === item.locationId);
                if (foundLoc) {
                    this._selectedLocation.setValue(foundLoc);
                    this._form.patchValue({ location: foundLoc });
                }
            }
        }
    }

    _OpenAccount() {
        if (this._currentUser.isEnterprise) {
            setTimeout(() => {
                this.kendoComboAccounts?.toggle(true);
                this.kendoComboAccounts?.focus();
            });
        }
        else {
            setTimeout(() => {
                this.kendoComboBreakdownInventory?.toggle(true);
                this.kendoComboBreakdownInventory?.focus();
            });
        }
    }


    ExpandCollapseGeneralInfoWidget(isExpand: boolean) {
        this.isGeneralInformationExpanded = !isExpand;
    }

    ExpandCollapseScanInventoryWidget(isExpand: boolean) {
        this.isScanInventoryExpanded = !isExpand;
    }


    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }
    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }
    _selectStocksHandler(): void {
        this._showStocksGrid = true;
    }


    _generateBarcodeClick() {
        this.runGenerateBarcode();
        if (this._itemType == 'serial') {
            setTimeout(() => {
                this._initBarCodePopupForm();
            }, 500);
        } else if (this._itemType == 'batch') {
            // this.expirationDateInput.focus();
        }
    }


    _handleSitesFilter(value: any) {
        if (!value) {
            this._sitesFiltered = this._sites;
            return;
        }
        const search = typeof value === 'string' ? value.toLowerCase() : '';
        this._sitesFiltered = (this._sites || []).filter(
            (s) => s.name?.toLowerCase().indexOf(search) !== -1
        );
    }


    _handleVendorsFilter(value: any) {
        if (!value) {
            this._vendorsFiltered = this._vendors;
            return;
        }
        const search = typeof value === 'string' ? value.toLowerCase() : '';
        this._vendorsFiltered = (this._vendors || []).filter(
            (s) => s.code?.toLowerCase().indexOf(search) !== -1
        );
    }

    _loadLocationsDD(siteId: number) {
        return this._locationsService.getLocationListingBySite(siteId)
            .subscribe((data: any) => {
                const locs = Array.isArray(data) ? data : (data?.body ?? data?.data ?? []);
                this._locations = locs;
                this._locationsFiltered = locs;
                if (this._selectedBreakdownInventory.value?.locationId) {
                    const foundLoc = this._locations.find(l => l.id === this._selectedBreakdownInventory.value.locationId);
                    if (foundLoc && !this._selectedLocation.value) {
                        this._selectedLocation.setValue(foundLoc);
                        this._form.patchValue({ location: foundLoc });
                    }
                }
            });
    }

    _handleLocationsFilter(value: any) {
        if (!value) {
            this._locationsFiltered = this._locations || [];
            return;
        }
        const search = typeof value === 'string' ? value.toLowerCase() : '';
        this._locationsFiltered = (this._locations || []).filter(
            (s) => s.code?.toLowerCase().indexOf(search) !== -1
        );
    }

    _handlePurchaseOrdersFilter(value: any) {
        if (this._poPreference != 'notValidated') {
            if (!value) {
                this._purchaseOrdersFiltered = this._purchaseOrders || [];
                return;
            }
            const search = typeof value === 'string' ? value.toLowerCase() : '';
            this._purchaseOrdersFiltered = (this._purchaseOrders || []).filter(
                (s) => s.code?.toLowerCase().indexOf(search) !== -1
            );
        }
    }

    _loadItemsDD(siteId: number, selectedItemId: number = null) {
        return this._stockItemsService.getStockItemsListingBySite(siteId)
            .subscribe((data: any) => {
                const items = Array.isArray(data) ? data : (data?.body ?? data?.data ?? []);
                this._items = items;
                this._itemsFiltered = items;
                if (selectedItemId != null) {
                    var newStock = this._items.find(x => x.id == selectedItemId);
                    if (newStock) {
                        this.quantityInput?.focus();
                        setTimeout(() => {
                            this._selectedStockItem.setValue(newStock);
                            this._form.patchValue({
                                selectedStock: { id: newStock.id, number: newStock.number }
                            });
                        });
                    }
                }
            });
    }

    _handleItemsFilter(value: any) {
        this._itemFilter = value;
        if (!value) {
            this._itemsFiltered = this._items || [];
            return;
        }
        const search = typeof value === 'string' ? value.toLowerCase() : '';
        this._itemsFiltered = (this._items || []).filter((item) => {
            return (item.number?.toString().toLowerCase().indexOf(search) > -1 ||
                item.description?.toLowerCase().indexOf(search) > -1 ||
                item.itemType?.name?.toLowerCase().indexOf(search) > -1);
        });
    }

    _handleItemsChange(value: any) {
        if (value != null) {
            if (value.itemType?.name) {
                this._itemType = this.getItemType(value.itemType.name);
            }
            this._form.patchValue({
                selectedStock: { id: value.id, number: value.number }
            });
            setTimeout(() => {
                this.quantityInput?.focus();
            });
        }
    }

    _addNewStock() {
        var value = this._itemFilter;
        if (this._addNewStockSettingEnabled && typeof value === 'string' && (this._items || []).findIndex(item => item.number === value) == -1) {
            var _accountSites: any[] = [];
            const siteVal = this._form.get('site')?.value;
            const siteId = siteVal && typeof siteVal === 'object' ? siteVal.id : siteVal;
            const accVal = this._selectedAccount?.value;
            const accId = accVal && typeof accVal === 'object' ? accVal.id : accVal;
            _accountSites.push({
                siteId: siteId,
                accountId: accId
            });
            var model: any = {};
            model.number = value;
            model.itemTypeId = 1;
            model.costTypeId = 1;
            model.receiveUnitOfMeasureId = 1;
            model.inventoryUnitOfMeasureId = 1;
            model.issueUnitOfMeasureId = 1;
            model['fileIds'] = [];
            model['vendorIds'] = [];
            model['stockItemAlternateCodes'] = [];
            model['accountSites'] = _accountSites;
            this._stockItemsService
                .createStockItem(model)

                .subscribe((response: any) => {
                    if (response != null && typeof response === 'number') {
                        this._loadItemsDD(this._form.get('site').value.id, parseInt(response.toString()));
                    }
                });
        }
    }

    _dateChanged(selectedDate: Date) {
        if (selectedDate >= this._minDate) {
            this._quantitySubmited();
        }
    }

    _quantitySubmited() {
        switch (this._itemType) {
            case "serial":
                if (this._inventoryCode.value == "" || this._inventoryCode.value == null) {
                    var generateBarcodeRan = false;
                    if (this._selectedStockItem.value && this._autoCodeGeneration.value) {
                        this.runGenerateBarcode();
                        generateBarcodeRan = true;
                    }
                    if (generateBarcodeRan) {
                        setTimeout(() => {
                            this._initBarCodePopupForm();
                        }, 500);
                    } else {
                        this._initBarCodePopupForm();
                    }
                    return;
                }
                break;
            case "batch":
            case "serial-with-quantity":
                if (this._inventoryCode.value == "" || this._inventoryCode.value == null) {
                    return;
                }
                if (this._expirationDate.value == "" || this._expirationDate.value == null) {
                    return;
                }
                break;
        }

        if (this._selectedStockItem.value) {
            setTimeout(() => {
                this.fillGrid();
            }, 500);
        }
    }

    _onSave(e: any) {
        if (!this._inventoryGridData.length) {
            this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Please add the items you want to Receive.',
                withoutConfirm: true
            });
        } else if (!this.checkInventoriesValiation()) {
            this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Please fill the required fields in the grid.',
                withoutConfirm: true
            });
        } else if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._invalidForm = false;
            const formModel = this._form.value;
            let model: any = {};
            model['entryDate'] = formModel.date;
            model['siteId'] = formModel.site?.id ?? formModel.site;
            model['vendorId'] = null;
            model['locationId'] = formModel.location?.id ?? formModel.location;
            model['stockPurchaseOrderId'] = null;
            model['stockPurchaseOrderPoNumber'] = '';
            model['breakdownInventoryId'] = this._selectedBreakdownInventory?.value?.id;
            model['breakdownQuantity'] = this._breakdownQuantity?.value;
            model['notes'] = this._notes?.value;
            model['items'] = this._inventoryGridData.map((x) => {
                return {
                    stockItemId: x.stockItemId,
                    itemTypeId: x.itemTypeId,
                    minQuantity: Number(x.minQuantity)?.toFixed(this.digitNumber),
                    maxQuantity: Number(x.maxQuantity)?.toFixed(this.digitNumber),
                    quantity: Number(x.quantity) ? Number(x.quantity) : 0,
                    inventoryNumber: (x.inventoryCode == null || x.inventoryCode === '') && (x.itemTypeId == 1 || x.itemType === 'standard') ? x.itemNumber : x.inventoryCode,
                    expirationDate: x.expirationDate
                };
            });
            model['poPreference'] = this._poPreference;
            this._receiveTransactionsService
                .createReceive(model)

                .subscribe((data: any) => {
                    this.transactionId = parseInt(data.message)
                    var msg = "";
                    if (data != null && data.message != null) {
                        msg = 'Receive Transaction # ' + data.message + ' has been processed successfully.';
                    } else {
                        msg = 'Error';
                    }
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: msg,
                        returnAfterOkCloseClick: true,
                        withoutConfirm: true
                    });
                    if (this._printReceipt.value) {
                        if (this._settingsPrintReceipt.receiveReportId != null) {
                            this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: this._settingsPrintReceipt.receiveReportId, transactionId: this.transactionId });
                            this._onClear();
                        }
                    }
                    else {
                        this._onClear();
                    }

                });
        }
    }

    _printReceiptReport() {
        this._onClear();
    }

    _removeHandler({ sender, dataItem }: any) {
        this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.itemNumber != dataItem.itemNumber);
    }

    _onQuantityChange(e: any, item: any) {
        item.quantity = e;
        item.receiveQty = e;

        if (item.itemType === 'serial') {
            this.generateBarcode(e)
                .subscribe((data: any) => {
                    item.inventoryCode = data.result.toString();
                });
        }
    }

    _onInventoryCodeChange(e: any, item: ReceiveTransaction) {
        item.inventoryCode = e;
    }

    _onExpirationDateChange(e: any, item: ReceiveTransaction) {
        item.expirationDate = e;
    }

    _openForm(formName: string) {
        //this._layoutComponent.openDialogForm(formComponentMapOptions[formName]);
    }

    _onClear() {
        this.transactionId = null;
        const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
        let initialSiteId = null;
        if (loggedInAccountSites !== '') {
            try {
                const parsed = JSON.parse(loggedInAccountSites);
                if (parsed && parsed.length > 0) {
                    initialSiteId = parsed[0].siteId;
                }
            } catch (e) {}
        }
        this._form.setValue({
            date: new Date(),
            site: initialSiteId,
            location: null,
            selectedStock: null
        });
        this._selectedBreakdownInventory.setValue(null);
        this._breakdownQuantity.setValue(null);
        this._selectedLocation.setValue(null);
        this._notes.setValue(null);
        this._selectedAccount.setValue(null);
        this._selectedStockItem.setValue(null);
        this._expirationDate.setValue(null);
        this._inventoryCode.setValue(null);
        this._autoCodeGeneration.setValue(null);
        this._defaultDate.setValue(null);
        this._defaultQuantity.setValue(null);
        this._inventoryGridData = [];
        this._printReceipt.setValue(null);
        this.showReports = false;
        if (initialSiteId) {
            this._loadAllDropdowns(initialSiteId);
        }
    }

    _initBarCodePopupForm() {
        if (!this._barcodePopupActive) {
            let inventoryValues: any[] = [];
            if (this._inventoryCode.value) {
                inventoryValues = this._inventoryCode.value.split(', ');
            }

            let record: any = {};
            for (let i = 0; i < this._quantity.value?.toFixed(this.digitNumber); i++) {
                record['field' + i] = inventoryValues[i] ? [inventoryValues[i], Validators.required] : [null, Validators.required];
                this._barcodePopupFormFields.push('field' + i);
            }

            this._barcodePopupForm = this._fb.group(record);
            this._barcodePopupActive = true;
            this._layoutManager.applyOverly();
        }
    }

    _barcodePopupClose() {
        this._barcodePopupFormFields = [];
        this._barcodePopupActive = false;
        this._layoutManager.removeOverlay();
    }

    _onBarcodePopupClear(field?: string) {
        if (field) {
            this._barcodePopupForm.get(field).setValue(null);
        } else {
            this._barcodePopupForm.reset();
        }
    }

    _onBarcodePopupSave() {
        let counter = 0;
        let inventoryCode = '';
        Object.keys(this._barcodePopupForm.controls).forEach(key => {
            if (counter > 0) {
                inventoryCode += ', ';
            }

            let fieldValue = this._barcodePopupForm.get(key).value;
            if (fieldValue) {
                inventoryCode += fieldValue;
            }

            counter++;
        });

        this._inventoryCode.setValue(inventoryCode);
        this._barcodePopupClose();

        this._quantitySubmited();
    }

    _barcodePopupGenerateBarcode(field?: string) {
        if (!field) {
            for (const key in this._barcodePopupForm.controls) {
                if (!this._barcodePopupForm.get(key).value) {
                    field = key;
                    break;
                }
            }
        }

        if (field) {
            this.generateBarcode(1)
                .subscribe((data: any) => {
                    this._barcodePopupForm.get(field).setValue(data.result.toString());
                });
        }
    }

    private runGenerateBarcode(item: StockItemSummary = null) {
        let counter = this._itemType === 'serial' ? this._quantity.value?.toFixed(this.digitNumber) : 1;
        this.generateBarcode(counter)
            .subscribe((data: any) => {
                this._inventoryCode.setValue(data.result.toString());
                if (item != null) {
                    if (item.itemType.id == 1) {
                        this._expirationDate.setValue(null);
                    }
                    let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);
                    if (!gridItem) {
                        this._inventoryGridData.push({
                            stockItemId: item.id,
                            itemNumber: item.number,
                            description: item.description,
                            quantity: this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,
                            receiveQty: this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,
                            uom: item.receiveUnitOfMeasure?.code,
                            receiveUM: item.receiveUnitOfMeasure?.code,
                            inventoryCode: this._inventoryCode.value || (item.itemType?.id == 1 ? item.number : ''),
                            expirationDate: this._expirationDate.value,
                            unitCost: item.costInfo?.cost,
                            unitcost: item.costInfo?.cost,
                            itemType: this.getItemType(item.itemType.name),
                            itemTypeId: item.itemType.id,
                            minQuantity: item.minqty,
                            maxQuantity: item.maxqty
                        });
                    }
                }
            });
    }

    private checkInventoriesValiation(): boolean {
        for (let item of this._inventoryGridData) {
            if (item.itemType === 'standard') {
                if (item.quantity <= 0) {
                    return false;
                }
            }

            if (item.itemType === 'non-inventory') {
                if (item.quantity <= 0 || !item.inventoryCode) {
                    return false;
                }
            }

            if (item.itemType !== 'non-inventory' && item.itemType !== 'standard') {
                if (item.quantity <= 0 || !item.inventoryCode) {
                    return false;
                }
            }
        }

        return true;
    }

    private getItemType(itemTypeName: string) {
        switch (itemTypeName) {
            case 'Standard':
                return 'standard';
            case 'Serial':
                return 'serial';
            case 'Batch':
                return 'batch';
            case 'Non Inventory':
                return 'non-inventory';
            case 'Serial with Quantity':
                return 'serial-with-quantity';
        }
    }

    private generateBarcode(quantity: number) {
        return this._barcodeGeneratorsService
            .getBarcode('inventories', quantity);
    }

    private _initForm() {
        const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
        let initialSiteId = null;
        if (loggedInAccountSites !== '') {
            try {
                const parsed = JSON.parse(loggedInAccountSites);
                if (parsed && parsed.length > 0) {
                    initialSiteId = parsed[0].siteId;
                }
            } catch (e) {}
        }

        this._form = this._fb.group({
            date: [new Date(), Validators.required],
            site: [initialSiteId, Validators.required],
            location: [null, Validators.required],
            selectedStock: null
        });
    }

    private fillGrid() {
        let item = this._selectedStockItem.value;
        if (!item) return;
        if (typeof item === 'number' || typeof item === 'string') {
            item = (this._items || []).find(x => x.id === item || x.number === item) || { id: item };
        }
        let gridItem = this._inventoryGridData.find(x => x.itemNumber === item.number);

        if (!gridItem || (gridItem && item.itemType?.name?.toLocaleLowerCase() == 'batch')) {
            this._stockItemsService.getStockItem(item.id)

                .subscribe((data) => {
                    if (item.itemType?.id == 1) {
                        this._expirationDate.setValue(null);
                    }
                    this._inventoryGridData.push({
                        stockItemId: data.id,
                        itemNumber: data.number,
                        description: data.description,
                        quantity: this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,
                        receiveQty: this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,
                        uom: data.receiveUnitOfMeasure?.code,
                        receiveUM: data.receiveUnitOfMeasure?.code,
                        inventoryCode: this._inventoryCode.value || ((item.itemType?.id == 1 || data.itemType?.id == 1) ? data.number : ''),
                        expirationDate: this._expirationDate.value,
                        unitCost: data.costInfo?.cost,
                        unitcost: data.costInfo?.cost,
                        itemType: this.getItemType(data.itemType?.name),
                        itemTypeId: item.itemType?.id,
                        minQuantity: item.minQuantity,
                        maxQuantity: item.maxQuantity
                    });

                    this._selectedStockItem.setValue(null);
                });
        } else {
            this._selectedStockItem.setValue(null);
            this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'This item is already added to the grid. Please select another item.',
                returnAfterOkCloseClick: true,
                withoutConfirm: true
            });
        }
    }

    getDateEnabledOption() {
        this._TransactionDateEditting.getTransactionDateEditing("get-data")

            .subscribe((x: any) => {
                if (x != null && x != undefined) {
                    this._dateEnabled = x.transactionDateEditing;
                }
            })
    }

}
